import { apiServiceConstants } from "../../constants";
import { apiService, utilService } from "../../services";
import {
  MyPatientsResponse,
  ProviderDataResponse,
} from "./MyPatientsDataModels";

const getPatients = async (reqParams: {}): Promise<MyPatientsResponse> => {
  return await apiService
    .apiCall(
      `sboard/unit/my-patient/list/?reg_code=${utilService.getNetwork()}`,
      reqParams,
      apiServiceConstants.GET,
      utilService.getDeviceType()
    )
    .then((res) => {
      const response = res as MyPatientsResponse;
      return {
        isSuccess: response.isSuccess,
        message: response.message,
        status: response.status,
        result: response.result,
      };
    })
    .catch((err) => {
      const error = err as MyPatientsResponse;
      return {
        isSuccess: error.isSuccess,
        message: error.message,
        status: error.status,
        result: error.result,
      };
    });
};

const getProvidersList = async (reqParams: {
  [key: string]: any;
}): Promise<ProviderDataResponse> => {
  return await apiService
    .apiCall(
      `sboard/unit/sboard-schedules/doctor-v2/?reg_code=${utilService.getNetwork()}&bedId=${
        reqParams.bedId
      }&hour=${reqParams.hour}&minute=${reqParams.minute}&date=${
        reqParams.date
      }`,
      reqParams,
      apiServiceConstants.POST,
      utilService.getDeviceType()
    )
    .then((res) => {
      const response = res as ProviderDataResponse;
      return response;
    })
    .catch((err) => {
      const error = err as ProviderDataResponse;
      return error;
    });
};

export const MyPatientsService = {
  getPatients,
  getProvidersList,
};
